// our  hard work TicketTable

import React, { Component } from "react";
//import Header from "./../ClaimsSearch/TableHeader";
//import TableData from "./../ClaimsSearch/TableData";
import { Pagination, Row, Col, Spin, Button } from "antd";
// import { connect } from "react-redux";
// import { fetchLoadData, unsubscribe } from "../../store/actions/webService";
import "./../ClaimsSearch/ProviderTable.css";
import "./Ticket.css";
import Config from "../../config";
import TicketSidebar from "./TicketSidebar";
//import Header from "./TicketTableHeader";
import TicketTableData from "./TicketTableData";
class TicketTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      QueueID: null,
      tp: true,
      activetab: true,
      ActiveBt: true,
      values: {
        TenantID: null,
        CreatedDate: null,
        TicketID: null,
        TicketType: null,
        CreatedFor: null,
        CreatedForID: null,
        CreatedBy: null,
        Status: null,
        NpiDetails: [],
        TaxDetails: [],
        TAXIDNPIMapping: [],
        Roles: null,
        QueueID: null,
        SortTerm: null,
        IsAscending: true,
        PageNumber: 1,
        PageSize: 15,
        IsActive: true
      },
    };
  }
  onSidebarClick = (buttonName) => {
    console.log("we come in",buttonName);
    // console.log("printtt",this.props);
    this.setState({
      QueueID: buttonName,
    });
  };
  btnActiveClick = () => {
 //   console.log("ttrtrt",this.props.IsActive);
    let activeValues = JSON.parse(JSON.stringify(this.state.values));
    // console.log("vallltoo",activeValues)

    activeValues.IsActive = true;

    this.setState({
      ActiveBt: true,
      activetab: true,
     // loader: true,
    });
    
  };
  btnClosedClick = () => {

    this.setState({
    //  showEventStatus: false,
    //  values: closedValues,
    //  closedTab: true,
      activetab: false,
      ActiveBt: false,
    //  loader: true,
    });
  };

  componentDidMount() {
    this.getTicketsData();
  }

  getTicketsData = async () => {
    let filter = this.state.filter;
    let data = await fetch(Config.Ticket + "/GetTickets", {
      method: "POST",
      headers: {
        Authorization: sessionStorage.getItem("access_token"),
        Accept: "application/json",
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        TenantID: sessionStorage.getItem("Tanent"),
        // "TenantID": 100,
        CreatedDate: null,
        TicketID: null,
        TicketType: null,
        CreatedFor: null,
        CreatedForID: null,
        CreatedBy: null,
        Status: null,
        NpiDetails: sessionStorage.getItem("npivalue") !== null ? JSON.parse(
          sessionStorage.getItem("npivalue")
        ) : [],
        TaxDetails: sessionStorage.getItem("taxid") !== null ? JSON.parse(
          sessionStorage.getItem("taxid")
        ) : [],
        TAXIDNPIMapping: sessionStorage.getItem("taxidNpiMapping") !== null ? JSON.parse(
          sessionStorage.getItem("taxidNpiMapping")
        ) : [],
        Roles: sessionStorage.getItem("rolename").split(','),
        QueueID: null,
        SortTerm: null,
        IsAscending: true,
        PageNumber: 1,
        PageSize: 15,
        IsActive: true,
      }),
    });
    data = await data.json();
  };

  render() {
   // console.log("gggg",this.state.activeSidebar)
    const createButton = () => {
      this.props.getDetails({ type: "Create Ticket" });
    };

    return (
      <>
        <div>
          <div
            className="customScroll"
            style={{
              float: "left",
              width: "12vw",
              overflowX: "hidden",
              overflowY: "auto",
              maxHeight: "88vh",
            }}
          >
            <TicketSidebar
            sidebarClick={this.onSidebarClick}
            sidebarActiveKey={this.state.QueueID}
            />
            {/* sidebar */}
          </div>
          <div
          style={{
            float: "left",
            width:  "84%",
            marginLeft: "3%"
          }}
        >
          {<Row style={{ paddingBottom: "1em", paddingLeft: "2em" }}>
            <Col span={20}>
              <button
                style={{
                  width: "90px",
                  borderTopLeftRadius:
                    this.state.activetab === true ? "5px" : "5px",
                  borderBottomLeftRadius:
                    this.state.activetab === true ? "5px" : "5px",
                  borderWidth: "2px",
                  height: this.state.activetab === true ? "1.8em" : "2em",
                  marginLeft: "-1.8vw",
                  borderColor: "rgba(0,0,0,.15)",
                  borderStyle:
                    this.state.activetab === true
                      ? "none"
                      : "solid none solid solid",
                }}
                className={
                  this.state.activetab === true
                    ? "details-tab-sidebar-queues"
                    : "simple-button"
                }
                onClick={this.btnActiveClick}
              >
                Active
              </button>
              <button
                style={{
                  width: "90px",
                  borderTopRightRadius:
                    this.state.closedTab === true ? "5px" : "5px",
                  borderBottomRightRadius:
                    this.state.closedTab === true ? "5px" : "5px",
                  borderColor: "rgba(0,0,0,.15)",
                  borderWidth: "2px",
                  height: this.state.closedTab === true ? "1.8em" : "2em",
                  borderStyle:
                    this.state.closedTab === true
                      ? "none"
                      : "solid solid solid none",
                  paddingTop: "0.2em",
                  paddingBottom: "0.2em",
                }}
                className={
                  this.state.activetab === false
                    ? "details-tab-sidebar-queues"
                    : "simple-button"
                }
                onClick={this.btnClosedClick}
              >
                Closed
              </button>
              <span
                style={{
                  color: "#16345F",
                  fontWeight: "bold",
                  marginLeft: "0.5em",
                }}
              >
               
              </span>
            </Col>
           
            {/* <Button
            style={{
              background:
                "transparent linear-gradient(100deg, #4083F2 0%, #609BFF 0%, #3B79E6 100%, #548DED 100%) 0% 0% no-repeat padding-box",
              boxShadow: "5px 5px 10px #3979E934",
              borderRadius: "4px",
              opacity: 1,
              textAlign: "center",
              fontFamily: "Montserrat",
              fontSize: "12px",
              fontWeight: 500,
              color: "#FFFFFF",
              width: "140px",
              marginLeft: "6px",
            }}
            onClick={createButton}
          >
            Create a Ticket
          </Button> */}
          </Row>}
        
          {/* )} */}

          {/* {this.state.loader === true ? (
            <div
              style={{ marginTop: "20vh", textAlign: "center", height: "39vh" }}
            >
              <Spin size="large" />
              <div className="loadingData">
                Loading Table data...
              </div>
            </div>
          ) : ( */}
            <Row>
              <Col span={24}>
                {/* {this.state.noData === false &&
                  this.state.headers &&
                  this.state.Dummytable.length > 0 && ( */}
                    <TicketTableData
                       clickActive={this.state.ActiveBt}
                       selectedSidebar={this.state.QueueID}
                    />
                  {/* )} */}
                
              </Col>
            </Row>
          {/* )} */}

          {!this.state.eventSearch && this.state.path === "/profile-search" &&
            <div className="noDataMessage pt-5" style={{ textAlign: "center" }}>Search with different parameters</div>
          }
          {/* {this.state.noData === false &&
            this.state.headers &&
            this.state.Dummytable.length > 0 && ( */}
           
            {/* )} */}

          {this.state.noData === true && (
            // <div
            //   style={{
            //     fontFamily: "Montserrat",
            //     textAlign: "center",
            //     marginTop: "24vh",
            //   }}
            // >
            //   <h1>No Record found</h1>
            // </div>

            <div className="npdata-text mt-5 pt-5">
              No results found. <br></br>
              Please check the search criteria and try again.
            </div>
          )}
        </div>
          {/* <div>
            Table will come here
          </div> */}
        </div>
      </>
    );
  }
}

export default TicketTable;
